import { AnyAction, Dispatch } from 'redux';
import { ClientUserProfileGateway } from '../../../infra/adapters/luminara/userprofile/client-user-profile-gateway';
import { ClientSettingsAction } from '../../../store/reducers/client-settings.reducer';
import { selectClientUserProfilePresentation } from '../../../store/selectors/client-settings.selector';
import { setLoggedUserProfile } from '../../../store/selectors/global.selector';
import { AppState } from '../../../store/store';
import { ThunkResult } from '../shared/ThunkResult';

export const loadMyProfileAsClient = (
  clientUserProfileId: string
): ThunkResult<{
  clientUserProfileGateway: ClientUserProfileGateway;
}> => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => AppState, { clientUserProfileGateway }) => {
    try {
      const currentUser = selectClientUserProfilePresentation(getState());
      if (currentUser?.email != null && currentUser.id === clientUserProfileId) {
        return;
      } else {
        const clientData = await clientUserProfileGateway.getClientUserProfile(clientUserProfileId);
        dispatch({ type: 'LOAD_CLIENT_USER_PROFILE_SUCCESS', payload: clientData } as ClientSettingsAction);
        dispatch(setLoggedUserProfile(clientData));
      }
    } catch (error: any) {
      dispatch({ type: 'LOAD_CLIENT_USER_PROFILE_FAILURE', payload: error } as ClientSettingsAction);
    }
  };
};
